import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export const useIsPaywallPaymentSettingsAvailable = () => {
  const { currentCommunity } = usePunditUserContext();
  return !!currentCommunity?.policies?.is_paywall_payment_settings_available;
};
